<template>
	<PageTemplate>
		<template slot="title">
			Publications
		</template>
		<template slot="content">
			<v-layout>
				<v-flex xs12>	
					<v-container 
						grid-list-xl
						fluid
						class="divider-line"
						v-for="(item,i) in items"
						:key="i"
					>
						<v-layout row wrap>
							<v-flex xs12 sm4 class="image-border">
								<div
									class="gallery-item"
									:style="'background-image:url('+item.img+');'"
								/>
							</v-flex>
							<v-flex xs12 sm8 >
								<a :href="item.link" target="blank">
									<h2>{{item.title}}</h2>
								</a>
								<p class="published-info">
									{{item.citation}}
								</p>
								<p>
								{{item.text}}
								<br>
								<br>
									<a :href="item.link" target="blank"><v-icon>open_in_new</v-icon> {{item.link}} </a>
								</p>
							</v-flex xs12>
						</v-layout>
					</v-container>
				</v-flex>
			</v-layout>
		</template>
	</PageTemplate>
</template>

<script>
import PageTemplate from './PageTemplate'
export default {
  name: 'publications',
  data () {
    return {
		items:[
			{
				img:'./img/publications/publications1.jpg',
				title:'Classification of Single Particles from Human Cell Extract Reveals Distinct Structures',
				citation:`Cell Rep. 2018 Jul 3;24(1):259-268.e3. doi: 10.1016/j.celrep.2018.06.022.`,
				link:`https://www.ncbi.nlm.nih.gov/pubmed/29972786`,
				text:`
					Verbeke et al. show how multiple structures can be obtained and identified using a high-throuput cryo-EM pipeline coupled with mass spectrometry.
					`,
			},
			{
				img:'./img/publications/publications2.jpg',
				title:'Cas4-Dependent Prespacer Processing Ensures High-Fidelity Programming of CRISPR Arrays',
				citation:`Mol Cell. 2018 Apr 5;70(1):48-59.e5. doi: 10.1016/j.molcel.2018.03.003. Epub 2018 Mar 27.`,
				link:`https://www.ncbi.nlm.nih.gov/pubmed/29602742`,
				text:`
					In collaboration with the Sashital lab at Iowa State University, Yi Zhou from the Taylor lab reveals the structure of a pre-spacer processing machine.
					`,
			},
		]
    }
  },
  components:{
	PageTemplate
  }
}
</script>

<style scoped>
img{
	width:100%;
	height:auto;
	border: 1px solid #cccccc;
	padding:5px;
}
p{
	text-align:justify;
}
h2{
	padding-top:0;
	margin-bottom:0;
	font-size:30px;
}
.divider-line{
	border-bottom: 1px solid #cccccc;
}
.published-info{
	font-size:14px;
	color:#000000;
	padding-left:10px;
}
a h2:hover{
	color:#bf5700;
}
.gallery-item{
	width:100%;
	height:100%;
	min-height:230px;
	display:inline-block;
	background-repeat:no-repeat;
	background-size:cover;
	background-position:top,center;
}
.image-border{
	border: 1px solid #cccccc;
	padding:5px !important;
	margin:10px 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Publications.vue